module.exports = __webpack_public_path__ + "static/media/collage4.aac2ea9b.png";